import * as React from 'react';
import styled from 'styled-components';
import { SkeletonLoader } from '@ally/metronome-ui';
const SkeletonWrapper = styled.main `
  ${({ theme: { space } }) => `
    *,
    ::before,
    ::after {
      margin: 0;
      box-sizing: border-box;
    }

    && {
      width: 100%;
      max-width: 1192px;
      margin: ${space.xs} auto;
      padding: 0 ${space.xs};
    }
  `}
`;
export const RouteSkeleton = () => (React.createElement(SkeletonWrapper, null,
    React.createElement(SkeletonLoader.Container, { "data-testid": "route-skeleton" },
        React.createElement(SkeletonLoader.Row, { height: "xl", width: "xl" }),
        React.createElement(SkeletonLoader.Row, { height: "xl", width: "xl" }))));
//# sourceMappingURL=RouteSkeleton.js.map